/**
 * 管理者セットアップ画面
 */

import { Loader2, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/hooks/use-auth";
import { apiClient } from "@/lib/api-client";

interface AdminSetupScreenProps {
  onComplete: () => void;
}

export function AdminSetupScreen({ onComplete }: AdminSetupScreenProps) {
  const { user } = useAuth();
  const [isSettingUp, setIsSettingUp] = useState(false);

  const handleSetup = async () => {
    setIsSettingUp(true);
    try {
      const response = await apiClient.api.admin.setup.$post();

      if (response.ok) {
        toast.success("管理者として登録されました");
        onComplete();
      } else {
        const data = await response.json();
        toast.error((data as { error?: string }).error ?? "セットアップに失敗しました");
      }
    } catch {
      toast.error("セットアップに失敗しました");
    } finally {
      setIsSettingUp(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <ShieldCheck className="mx-auto h-12 w-12 text-primary" />
          <CardTitle className="mt-4">管理者セットアップ</CardTitle>
          <CardDescription>
            現在管理者が登録されていません。
            <br />
            あなたを最初の管理者として登録しますか？
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg bg-muted p-3 text-sm">
            <p className="font-medium">{user?.name}</p>
            <p className="text-muted-foreground">{user?.email}</p>
          </div>
          <Button className="w-full" onClick={handleSetup} disabled={isSettingUp}>
            {isSettingUp ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <ShieldCheck className="mr-2 h-4 w-4" />
            )}
            管理者として登録
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
